module.exports = new __parcel__URL__("fo_hero_3.64ac82fc.png").toString();